import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AngularFireDatabase } from '@angular/fire/database';
import { Observable } from 'rxjs';
import 'firebase/database';


@Component({
  selector: 'app-build-chatbot',
  templateUrl: './build-chatbot.component.html',
  styleUrls: ['./build-chatbot.component.scss']
})
export class BuildChatbotComponent implements OnInit {
  clients: Observable<any[]>;
  registerForm: FormGroup;
  submitted = false;

  constructor(private formBuilder: FormBuilder, private fireDatabase: AngularFireDatabase,
              private router: Router, private toastr: ToastrService) {

  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      fullName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });


  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  onSubmit() {


    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }

    const currentDate = new Date();
    const client = {
      name: this.f.fullName.value,
      email: this.f.email.value,
      createdAt: currentDate.toJSON('yyyy-MM-dd HH:mm')
    };

    // save client
    this.fireDatabase.list('/signed-clients').push(client).then((d: any) => {
      this.toastr.success('You information has been sent and you will be contacted and given instructions soon.', 'Success');
      this.submitted = true;
      // redirect to home
      setTimeout(() => {
        this.router.navigate(['/']);
      }, 5000);

    }).catch(e => {
      this.toastr.error('Somthing wrong, please try again later!', 'Error');
    });
  }

}
